import { LineInfoIcon } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/LineInfoIcon';

import { Box, InputAdornment, SxProps, TextField, Theme, Typography } from '@mui/material';

type AmountFieldProps = Readonly<{
  id: string;
  label: string;
  tooltip: string;
  value: number | null;
  onChange: (value: number | null) => void;
}>;

const MAX_AMOUNT = 10_000_000;

const parseAmount = (raw: string) => {
  const [whole, fraction = ''] = raw.replace(/[^\d.]/g, '').split('.');

  if (whole === '' && fraction === '') return null;

  return Math.min(Math.round(Number(`${whole || '0'}.${fraction}`)), MAX_AMOUNT);
};

export const AmountField = ({ id, label, tooltip, value, onChange }: AmountFieldProps) => (
  <Box sx={fieldSx}>
    <Box sx={labelRowSx}>
      <Typography component="label" htmlFor={id} variant="text-sm-medium">
        {label}
      </Typography>
      <LineInfoIcon idPrefix={id} info={{ kind: 'tooltip', text: tooltip }} />
    </Box>
    <TextField
      id={id}
      value={value === null ? '' : String(value)}
      onChange={(event) => onChange(parseAmount(event.target.value))}
      inputProps={{ inputMode: 'numeric', autoComplete: 'off' }}
      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
      fullWidth
    />
  </Box>
);

const fieldSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
});

const labelRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
};
